import { gql } from "@apollo/client";

import { adminStatusFragment } from "./AdminStatusFragment";
import { caseSummaryFragment } from "./CaseSummaryFragment";
import { ruleExecutionDetailsFragment } from "./RuleExecutionDetailsFragment";
import { scenarioVersionFragment } from "./ScenarioVersionFragment";
import { userFragment } from "./UserFragment";

export const scenarioExecutionResultWithCaseFragment = gql`
  fragment ScenarioExecutionResultWithCaseFragment on ScenarioExecutionResult {
    id
    globalScore
    date
    mode
    date
    scenarioVersion {
      ...ScenarioVersionFragment
    }
    alert {
      id
      adminStatus {
        ...AdminStatus
      }
    }
    triggeredBy {
      ...UserFragment
    }
    ruleExecutionDetails {
      ...RuleExecutionDetailsFragment
    }
    caseVersions {
      creation {
        ...CaseSummaryFragment
      }
      current {
        ...CaseSummaryFragment
      }
    }
  }
  ${scenarioVersionFragment}
  ${adminStatusFragment}
  ${userFragment}
  ${ruleExecutionDetailsFragment}
  ${caseSummaryFragment}
`;
